import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CloseButton from "../CloseButton/CloseButton";
import useVerticalResize from "../../../utils/hook/useVerticalResize";

const DEFAULT_HEIGHT = 640;
const MIN_HEIGHT = 360;
const HEIGHT_STORAGE_KEY = "aiChatHeight";

// AiChat.js with URLSearchParams for better URL construction
const AiChat = ({ onClose }) => {
  const [loading, setLoading] = useState(true);

  // Get parameters from Redux store
  const modalParams = useSelector((state) => state.dashboard.modalParams);
  const { promptSuggestions = [], opensession = false } = modalParams;

  // The panel keeps whatever height the user dragged it to, across sessions.
  const { height, resizing, handleProps } = useVerticalResize({
    defaultHeight: DEFAULT_HEIGHT,
    minHeight: MIN_HEIGHT,
    storageKey: HEIGHT_STORAGE_KEY,
  });

  // Construct URL with query parameters
  const urlParams = new URLSearchParams();
  urlParams.set('suggestions', JSON.stringify(promptSuggestions));
  if (opensession) {
    urlParams.set('opensession', 'true');
  }

  const iframeUrl = `/aichat?${urlParams.toString()}`;

  //console.log(iframeUrl)

  // Reset loading state when parameters change
  useEffect(() => {
    setLoading(true);
  }, [promptSuggestions, opensession]);

  return (
    <div
      className={`aichat-container${resizing ? " aichat-container--resizing" : ""}`}
      style={{ height: `${height}px` }}>
      {/* Close button */}
      <div className="aichat-close">
        <CloseButton onClick={onClose} />
      </div>

      {/* Loader */}
      {loading && <div className="loader"></div>}

      <iframe
        src={iframeUrl}
        className="aichat-container__iframe"
        title="Sub AiChat App"
        onLoad={() => setLoading(false)}
      />

      {/* Bottom edge: drag to make the panel taller or shorter */}
      <div
        className="aichat-container__resizer"
        title="Drag to resize, double click to reset"
        aria-label="Resize chat panel"
        {...handleProps}
      />
    </div>
  );
};

export default AiChat;
